export const emptySectionText = 'Go to product library to add your first product';
export const emptySectionTextFilter =
  'No results found. Please change your filter criteria to view products for pricing';
export const emptySectionButtonText = 'Go to product library';
